import { ANALYTICS_EVENTS } from '@/constants/analytics';
import { segmentClient } from '@/util/analytics';
import { fetchClient } from '@/util/fetchClient';

export async function deleteDraftV2(draftId: string) {
  try {
    const { data } = await fetchClient.DELETE('/v2/drafts/{draftUuid}', {
      params: {
        path: {
          draftUuid: draftId,
        },
      },
    });

    segmentClient.track(ANALYTICS_EVENTS.DRAFT_DELETED, {
      draftId,
    });

    return data;
  } catch (error) {
    segmentClient.track(ANALYTICS_EVENTS.DELETE_DRAFT_FAILED, {
      draftId,
      error: JSON.stringify(error),
    });

    throw error;
  }
}
